module.exports = __webpack_public_path__ + "assets/imgs/mobile.899b6e07.png";